import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
/**
 * This service will be used to encrypt and decrypt data
 * it will use *********** method
 */
export class CryptHelperService {

  //private ske: string =  "PPUwU00PLOO93as7ca8sdash3rjo1xzgddje3355d56d4298713xa3az5OwO643s";
  private ske: string = "UwUOwO21idlpArA93caPatrr";
  private ivi: string = "UwU92apdAr456asP";

  constructor() { }

  /**
   * Encrypt a string and return the crypted one
   * @param value the string to be crypted
   * @returns the crypted string
   */
  encryptString(value: string): string {

    // parse ske and ivi to correct format
    let skeCorrect = CryptoJS.enc.Utf8.parse(this.ske);
    let iviCorrect = CryptoJS.enc.Utf8.parse(this.ivi);

    return CryptoJS.AES.encrypt(value, skeCorrect,
    {
      keySize: 128 / 8,
      iv: iviCorrect,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
    ).toString();
  }

  /**
   * Decryt an already cripted string
   * @param value the value to decrypt
   * @returns the oraginal value
   */
  decryptString(value: string): string {

    // parse ske and ivi to correct format
    let skeCorrect = CryptoJS.enc.Utf8.parse(this.ske);
    let iviCorrect = CryptoJS.enc.Utf8.parse(this.ivi);

    return CryptoJS.AES.decrypt(value, skeCorrect, 
      {
        keySize: 128 / 8,
        iv: iviCorrect,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
      ).toString(CryptoJS.enc.Utf8);
  }


  /*shit for encrypting links*/ 

  encryptStringAlt(value: string): string {

    // parse ske and ivi to correct format
    let skeCorrect = CryptoJS.enc.Utf8.parse(this.ske);
    let iviCorrect = CryptoJS.enc.Utf8.parse(this.ivi);

    let withSlash = CryptoJS.AES.encrypt(value, skeCorrect,
    {
      keySize: 128 / 8,
      iv: iviCorrect,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
    ).toString();

    return withSlash.replaceAll('+','usdHJK473').replaceAll('/','dfs678GH').replaceAll('=','hjkHKJ742l');
  }

  /**
   * Decryt an already cripted string
   * @param value the value to decrypt
   * @returns the oraginal value
   */
  decryptStringAlt(value: string): string {

    // parse ske and ivi to correct format
    let skeCorrect = CryptoJS.enc.Utf8.parse(this.ske);
    let iviCorrect = CryptoJS.enc.Utf8.parse(this.ivi);

    value = value.replaceAll('usdHJK473', '+' ).replaceAll('dfs678GH', '/').replaceAll('hjkHKJ742l', '=');
    
    return CryptoJS.AES.decrypt(value, skeCorrect, 
      {
        keySize: 128 / 8,
        iv: iviCorrect,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
      ).toString(CryptoJS.enc.Utf8);
  }

  /**
   * Encrypt all the data in the array
   * @param value an array of strings
   * @returns the crypted array
   */
  encryptArrayOfString(value: Array<string>): Array<string> {
    value.forEach(x => {
      x = CryptoJS.AES.encrypt(x, this.ske.trim()).toString();
    });
    return value;
  }


  decryptArrayOfString(value: Array<string>): Array<string> {
    value.forEach(x => {
      x = CryptoJS.AES.decrypt(x, this.ske.toString()).toString(CryptoJS.enc.Utf8);
    });
    return value;    
  }


}
